import React from 'react'
import ValidationSchema from './ValidationSchema'
import { components } from 'cng-web-lib'
import ConnectorTranslationText from '../ConnectorTranslationText'
import { Card, CardContent, Grid } from '@material-ui/core'
import AccordionHeaderComponent from '../../../common/ui/AccordionHeaderComponent'


const {
  form: {
    field: {
      CngTextField
    }
  }, CngGridItem
} = components


function Fields({ ...props }) {

  const { disabled } = props
  const {
    connectorMappings, connectorMappingName, connectorMappingInputSource, connectorMappingOutputSource
  } = ConnectorTranslationText()


  return (<>
      <Grid container spacing={3}>
        <CngGridItem xs={12} sm={12}>
          <Card>
            <CardContent>
              <Grid container>

                <AccordionHeaderComponent
                  title={connectorMappings} />

                <Grid container spacing={2}>
                  <CngGridItem xs={4} sm={4}>
                    <CngTextField
                      required
                      name='name'
                      label={connectorMappingName}
                      disabled={disabled}
                    />

                  </CngGridItem>

                  <CngGridItem xs={4} sm={4}>
                    <CngTextField
                      required
                      name='inputSource'
                      label={connectorMappingInputSource}
                      disabled={disabled}
                    />
                  </CngGridItem>


                  <CngGridItem xs={4} sm={4}>
                    <CngTextField
                      required
                      name='outputSource'
                      label={connectorMappingOutputSource}
                      disabled={disabled}
                    />
                  </CngGridItem>


                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </CngGridItem>
      </Grid>
    </>

  )
}


function toServerDataFormat(localData) {
  return localData
}

const DEFAULT_INITIAL_VALUES = {
  name: '', inputSource: '', outputSource: ''
}

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES }, makeValidationSchema: ValidationSchema
}

const ConnectorMappingsFormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields
})

export default ConnectorMappingsFormProperties